module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content programs-overview"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programs'
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("programs")])]), _c('h1', {
    staticClass: "h-sm category"
  }, [_vm._v(_vm._s(_vm.categoryName))])], 1), _c('div', {
    staticClass: "col-8_xs-12 week"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, [(_vm.noEvents) ? _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('h3', {
    staticClass: "h-xl"
  }, [_vm._v("Sorry!")]), _c('p', {
    staticClass: "h-sm"
  }, [_vm._v("There are no " + _vm._s(_vm.category.toLowerCase()) + " events scheduled. Check back soon, or sign up for our newsletter below to get regular updates.")])]) : _vm._e(), _vm._l((_vm.data), function(program) {
    return _c('div', {
      staticClass: "col-8_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.programCategory(program),
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])], 1)
  })], 2), _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "arrow left",
    on: {
      "click": _vm.prevPage
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/left_arrow.svg"
    }
  })]), _vm._l((_vm.numPages), function(page) {
    return _c('p', {
      class: {
        active: _vm.active(page)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(page)
        }
      }
    }, [_vm._v(_vm._s(page + 1))])
  }), _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.nextPage
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icons/right_arrow.svg"
    }
  })])], 2)])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35dd512d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgramsOverview.vue
// module id = 233
// module chunks = 1